import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import TypeCardGrid from "../../design-system/templates/type-card-grid-content-promo"
import VariantContainer from '../../design-system/atoms/variant-container'

const AdditionalBenefits = () => {
  const { trainingIcon, permissionIcon } = useStaticQuery(graphql`
    query {
      permissionIcon: file(
        relativePath: {
          eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Map Editor/Icons/permissions_icon.svg"
        }
      ) {
        publicURL
      }
      trainingIcon: file(
        relativePath: {
          eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Map Editor/Icons/training_icon.svg"
        }
      ) {
        publicURL
      }
    }
  `)

  const cardContents = [
    {
      logo: trainingIcon.publicURL,
      title: "Training and Support",
      description:
        "Mappedin provides onboarding, training, and ongoing support of our Map Editor tool.",
    },
    {
      logo: permissionIcon.publicURL,
      title: "Permission Levels",
      description:
        "Grant specific permission levels to different members of your team as you collaborate in one central tool.",
    },
  ]

  return (
    <VariantContainer
      variants={[
        {padding: '64px 0'},
        null,
        {padding: '96px 0'},
      ]}
    >
      <TypeCardGrid
        title="Customer Success"
        description="Mappedin is dedicated to client success. Our platform offers an
      accessible suite of map management tools that add value to your
      business and its map users. In addition to onboarding and training,
      the Mappedin team provides ongoing support to ensure the success of
      your venue maps."
        cardContents={cardContents}
      />
    </VariantContainer>
  )
}

export default AdditionalBenefits
